// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2av4f","file":"styles_file__38lP1"};